import React from "react"
import { toNumber, isNaN, round } from "lodash"

// Components
import TooltipLoader from "./loader"

export const getItemTooltip = (department, widgetsData, location, tooltipValue) => {
  const datas = makeData(department, location)

  let items = []
  for (let data of datas) {
    if (widgetsData?.[data?.widgetInfo?._id?.$oid])
      items.push({
        data: widgetsData?.[data?.widgetInfo?._id?.$oid],
        id: data?.widgetInfo?._id?.$oid,
        title: data?.widgetInfo?.title,
        valueId: data?.widgetInfo?.data?.[0]?.valueId,
      })
  }

  if (location === "emploi-et-formation") {
    return (
      <div className="value_container">
        <div className="libelle">Nombre d'éducateurs</div>
        <div className="value">
          {`${tooltipValue} ${
            isNaN(
              getPurcentage(
                widgetsData,
                tooltipValue,
                "sum_total_educateur",
                "ede0c4d8-8c80-4ce6-8429-b00304f2257b"
              )
            )
              ? ""
              : "| " +
                getPurcentage(
                  widgetsData,
                  tooltipValue,
                  "sum_total_educateur",
                  "ede0c4d8-8c80-4ce6-8429-b00304f2257b"
                ) +
                "%"
          }`}
        </div>
        {!isNaN(
          round(
            widgetsData?.["percentage_sexe"]?.data?.[0]?.["17e38901-e44a-4325-9fe1-a4fb024ff6af"]
          )
        ) ? (
          <div className="value_sexe">
            <div className="men_container">
              <i className="fa fa-male" />
              <div className="sexe_value">{`${round(
                widgetsData?.["percentage_sexe"]?.data?.[0]?.[
                  "17e38901-e44a-4325-9fe1-a4fb024ff6af"
                ]
              )}`}</div>
              <span>%</span>
            </div>
            <div className="women_container">
              <i className="fa fa-female" />
              <div className="sexe_value">{`${round(
                widgetsData?.["percentage_sexe"]?.data?.[1]?.[
                  "17e38901-e44a-4325-9fe1-a4fb024ff6af"
                ]
              )}`}</div>
              <span>%</span>
            </div>
          </div>
        ) : (
          <TooltipLoader height="40px" />
        )}
        {!isNaN(
          round(widgetsData?.["moyenne_age"]?.data?.[0]?.["64f3d0a3-84e3-4d78-b0fe-52e654a73845"])
        ) ? (
          <>
            <div className="libelle">Âge moyen</div>
            <div className="value">
              {`${round(
                widgetsData?.["moyenne_age"]?.data?.[0]?.["64f3d0a3-84e3-4d78-b0fe-52e654a73845"]
              )} ans`}
            </div>
          </>
        ) : (
          <TooltipLoader height="60px" />
        )}
        {!isNaN(
          round(
            widgetsData?.["qualifications_sum"]?.data?.[0]?.["9c7318bc-c8e4-446d-87fb-1234cca89c0c"]
          )
        ) ? (
          <>
            <div className="libelle">Qualifications</div>
            <div className="value_with_label">
              {`${round(
                widgetsData?.["qualifications_sum"]?.data?.[0]?.[
                  "9c7318bc-c8e4-446d-87fb-1234cca89c0c"
                ]
              )} | ${round(
                widgetsData?.["qualifications_percent"]?.data?.[0]?.[
                  "476c1b37-f8c1-4017-938f-904ed134cd82"
                ],
                2
              )}`}
              <span>par éducateurs</span>
            </div>
          </>
        ) : (
          <TooltipLoader height="60px" />
        )}
        {widgetsData?.["top_discipline"]?.data?.[0]?.[
          widgetsData?.["top_discipline"]?.columns?.[1]?.uuid
        ] ? (
          <>
            <div className="libelle">Top discipline</div>
            <div className="value">
              {`${
                widgetsData?.["top_discipline"]?.data?.[0]?.[
                  widgetsData?.["top_discipline"]?.columns?.[1]?.uuid
                ]
              }`}
            </div>
          </>
        ) : (
          <TooltipLoader height="60px" />
        )}
      </div>
    )
  } else if (location === "pratiquants") {
    const licencesValue = round(
      widgetsData?.["licences_par_dep"]?.data?.[0]?.["c511c765-5027-4f03-8acd-f2bdb74db014"]
    )

    return (
      <div>
        <div className="libelle_pratique">Licences</div>
        {/* <div className="sub_libelle_pratique">
          <div className="value_pratique">{`${tooltipValue}`}</div>
        </div> */}
        {!isNaN(licencesValue) ? (
          <div className="sub_libelle_pratique">
            <div className="value_pratique">{`${licencesValue}`}</div>
          </div>
        ) : (
          <TooltipLoader height="20px" />
        )}
        {!isNaN(
          round(
            widgetsData?.["licences_feminine_par_dep"]?.data?.[0]?.[
              "c511c765-5027-4f03-8acd-f2bdb74db014"
            ]
          )
        ) ? (
          <div className="value_sexe">
            <div className="licences_men_container">
              <i className="fa fa-male" />
              <div className="sexe_value">{`${round(
                widgetsData?.["licences_masculine_par_dep"]?.data?.[0]?.[
                  "c511c765-5027-4f03-8acd-f2bdb74db014"
                ]
              )} | ${getPurcentagePratique(
                licencesValue,
                round(
                  widgetsData?.["licences_masculine_par_dep"]?.data?.[0]?.[
                    "c511c765-5027-4f03-8acd-f2bdb74db014"
                  ]
                )
              )}`}</div>
              <span>%</span>
            </div>
            <div className="licences_women_container">
              <i className="fa fa-female" />
              <div className="sexe_value">{`${round(
                widgetsData?.["licences_feminine_par_dep"]?.data?.[0]?.[
                  "c511c765-5027-4f03-8acd-f2bdb74db014"
                ]
              )} | ${getPurcentagePratique(
                licencesValue,
                round(
                  widgetsData?.["licences_feminine_par_dep"]?.data?.[0]?.[
                    "c511c765-5027-4f03-8acd-f2bdb74db014"
                  ]
                )
              )}`}</div>
              <span>%</span>
            </div>
          </div>
        ) : (
          <TooltipLoader height="40px" />
        )}
        {widgetsData?.["ff_licences_par_dep"]?.data?.[0]?.[
          widgetsData?.["ff_licences_par_dep"]?.columns?.[1]?.uuid
        ] ? (
          <div className="sub_libelle_pratique_federation">
            <div className="label">{`Top licenciés`}</div>
            <div className="value_pratique">
              {`${
                widgetsData?.["ff_licences_par_dep"]?.data?.[0]?.[
                  widgetsData?.["ff_licences_par_dep"]?.columns?.[1]?.uuid
                ]
              }`}
            </div>
          </div>
        ) : (
          <TooltipLoader height="50px" />
        )}
        <div className="libelle_pratique">Clubs</div>
        {!isNaN(
          round(widgetsData?.["clubs_par_dep"]?.data?.[0]?.["42cd9d07-5bde-49bf-8ab8-362804fa70bb"])
        ) ? (
          <div className="sub_libelle_pratique">
            <div className="value_pratique">{`${round(
              widgetsData?.["clubs_par_dep"]?.data?.[0]?.["42cd9d07-5bde-49bf-8ab8-362804fa70bb"]
            )}`}</div>
          </div>
        ) : (
          <TooltipLoader height="20px" />
        )}
        {widgetsData?.["ff_clubs_par_dep"]?.data?.[0]?.[
          widgetsData?.["ff_clubs_par_dep"]?.columns?.[1]?.uuid
        ] ? (
          <div className="sub_libelle_pratique_federation">
            <div className="label">{`Top clubs`}</div>
            <div className="value_pratique">{`${
              widgetsData?.["ff_clubs_par_dep"]?.data?.[0]?.[
                widgetsData?.["ff_clubs_par_dep"]?.columns?.[1]?.uuid
              ]
            }`}</div>
          </div>
        ) : (
          <TooltipLoader height="50px" />
        )}
      </div>
    )
  } else if (location === "lieux-de-pratique") {
    return (
      <>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "c41aef0e-ffe7-4204-bf59-97832302a586"
          ] ? (
            <>
              <div className="label_LDP">Présence CDESI :</div>
              <div className="value_LDP">
                {getPresenceCDESI(
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "c41aef0e-ffe7-4204-bf59-97832302a586"
                  ]
                )}
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "c41aef0e-ffe7-4204-bf59-97832302a586"
          ] ? (
            <>
              <div className="label_LDP">Avancement de la CDESI :</div>
              <div className="value_LDP">
                {getAvancementCDESI(
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "c41aef0e-ffe7-4204-bf59-97832302a586"
                  ]
                )}
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "c41aef0e-ffe7-4204-bf59-97832302a586"
          ] ? (
            <>
              <div className="label_LDP">{`Année ${getLabelAnneeCDESI(
                widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                  "c41aef0e-ffe7-4204-bf59-97832302a586"
                ]
              )}`}</div>
              <div className="value_LDP">
                {getAnneeCDESI(
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "c41aef0e-ffe7-4204-bf59-97832302a586"
                  ],
                  widgetsData
                )}
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        {/* <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "4c6cef89-d221-4282-9a76-227c021c0410"
          ] ? (
            <>
              <div className="label_LDP">Nombre de réunions plénière en 2019 :</div>
              <div className="value_LDP">
                {
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "4c6cef89-d221-4282-9a76-227c021c0410"
                  ]
                }
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "ef3191f6-3aa3-4a36-b517-a68b7ed7547c"
          ] ? (
            <>
              <div className="label_LDP">Nombre de groupes de travail en 2019 :</div>
              <div className="value_LDP">
                {
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "ef3191f6-3aa3-4a36-b517-a68b7ed7547c"
                  ]
                }
              </div>
            </>
          ) : (
            <div />
          )}
        </div> */}
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "c7db79bc-69f0-4228-8669-2d530174c71a"
          ] ? (
            <>
              <div className="label_LDP">Présence de PDESI :</div>
              <div className="value_LDP">
                {getPresencePDESI(
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "c7db79bc-69f0-4228-8669-2d530174c71a"
                  ]
                )}
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "5f25497d-d177-4e5a-8bfc-c0ea5db620d2"
          ] ? (
            <>
              <div className="label_LDP">Année de vote :</div>
              <div className="value_LDP">
                {new Date(
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "5f25497d-d177-4e5a-8bfc-c0ea5db620d2"
                  ]
                ).toLocaleDateString("fr-FR")}
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        {/* <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "5c84ba1a-467f-4789-87ca-391638447a34"
          ] ? (
            <>
              <div className="label_LDP">Nombre d'ESI inscrits :</div>
              <div className="value_LDP">
                {
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "5c84ba1a-467f-4789-87ca-391638447a34"
                  ]
                }
              </div>
            </>
          ) : (
            <div />
          )}
        </div> */}
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "b4d8955f-06fa-4b98-a629-28d83a9a3b7a"
          ] ? (
            <>
              <div className="label_LDP">Présence PDIPR :</div>
              <div className="value_LDP">
                {getPresencePDIPR(
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "b4d8955f-06fa-4b98-a629-28d83a9a3b7a"
                  ]
                )}
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        {/* <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "07d9a0f7-120d-4308-ab46-a6ea59ad98ad"
          ] ? (
            <>
              <div className="label_LDP">Schémas de développement :</div>
              <div className="value_LDP">
                {
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "07d9a0f7-120d-4308-ab46-a6ea59ad98ad"
                  ]
                }
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "34a12b89-a9e3-4bc3-952f-fde163139abc"
          ] ? (
            <>
              <div className="label_LDP">
                Nombre d’ETP mobilisés sur le développement des sports de nature :
              </div>
              <div className="value_LDP">
                {
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "34a12b89-a9e3-4bc3-952f-fde163139abc"
                  ]
                }
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <div>
          {widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
            "86649fd3-b088-4169-9f6e-69b80ca6852a"
          ] ? (
            <>
              <div className="label_LDP">
                % de la taxe d’aménagement dédiée aux sports de nature :
              </div>
              <div className="value_LDP">
                {
                  widgetsData?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.[
                    "86649fd3-b088-4169-9f6e-69b80ca6852a"
                  ]
                }
              </div>
            </>
          ) : (
            <div />
          )}
        </div> */}
      </>
    )
  } else {
    return (
      <div>
        <div className="value">{`${tooltipValue} | `}</div>
        {items.map(item => {
          return (
            <>
              <div className="libelle">{item?.title}</div>
              <div className="value">{item?.data?.data?.[0]?.[item?.valueId]}</div>
            </>
          )
        })}
      </div>
    )
  }
}

const getPurcentage = (widgetsData, tooltipValue, stringId, id) => {
  return round((tooltipValue * 100) / round(widgetsData?.[stringId]?.data?.[0]?.[id]), 1)
}

const getPurcentagePratique = (fullValue, value) => {
  return round((toNumber(value) * 100) / round(toNumber(fullValue)))
}

// moyenne_age v1 à afficher sur emploi-et-formation
export const makeData = (departement, location) => {
  if (location === "emploi-et-formation") {
    return [
      {
        widgetInfo: {
          _id: { $oid: "sum_total_educateur" },
          canBeCompared: true,
          category: {},
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "46867c11-e4b6-43ff-8b23-700d8aee85c7",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "aa33a1f7-9456-46b8-bf26-4ed9e5fb8be6",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "ede0c4d8-8c80-4ce6-8429-b00304f2257b",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImlkRWR1YyJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImlkRWR1YyJ9LCAidmVyc2lvbiI6IDJ9",
              name: "idEduc",
              calculus: "count",
              conditions: {},
              distinct: true,
            },
          ],
          groupBy: [],
          pageId: "620a361b3bbf2abc3965407d",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImlkRWR1YyJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "ede0c4d8-8c80-4ce6-8429-b00304f2257b",
                aggFunction: "count",
                distinct: true,
              },
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "46867c11-e4b6-43ff-8b23-700d8aee85c7",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "aa33a1f7-9456-46b8-bf26-4ed9e5fb8be6",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: { $oid: "percentage_sexe" },
          canBeCompared: true,
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImZvbmN0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "ca30a456-8666-4b7b-905f-e20b9a6b5722",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "bf1ab1bd-4184-4c94-ac71-695017949deb",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "17e38901-e44a-4325-9fe1-a4fb024ff6af",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImlkRWR1YyJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImlkRWR1YyJ9LCAidmVyc2lvbiI6IDJ9",
              name: "idEduc",
              calculus: "overallPercentage",
              conditions: {},
              distinct: true,
            },
          ],
          groupBy: [
            {
              valueId: "9c1b9892-9145-4d3b-a8d1-2c0b1be1823c",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImZvbmN0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImZvbmN0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "fonction",
              calculus: "sum",
              conditions: {},
            },
          ],
          isAdvancedConfig: {
            data: true,
            category: false,
            dependsOnField: false,
            groupBy: false,
          },
          pageId: "6202832b3bbf2abc3963d3dd",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImlkRWR1YyJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "17e38901-e44a-4325-9fe1-a4fb024ff6af",
                aggFunction: "overallPercentage",
                distinct: true,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImZvbmN0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "9c1b9892-9145-4d3b-a8d1-2c0b1be1823c",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJFZHVjYXRldXJcdTAwYjdyaWNlcyIsICJjb2x1bW5OYW1lIjogImZvbmN0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "ca30a456-8666-4b7b-905f-e20b9a6b5722",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "bf1ab1bd-4184-4c94-ac71-695017949deb",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          title: "My beautiful widget",
          widgetCategory: "chart",
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "qualifications_sum",
          },
          title: "Qualifications",
          category: {},
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "8221d529-715c-4cf2-9b8a-82d5eeb93fc9",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "639cd823-51c8-43e8-8f5d-33b81d302100",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "9c7318bc-c8e4-446d-87fb-1234cca89c0c",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJ2dWVfRWR1Y2F0ZXVyczw-TmJRdWFsaWYiLCAiY29sdW1uTmFtZSI6ICIjcXVhbGlmIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJ2dWVfRWR1Y2F0ZXVyczw-TmJRdWFsaWYiLCAiY29sdW1uTmFtZSI6ICIjcXVhbGlmIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "#qualif",
              calculus: "count",
              conditions: {},
              distinct: false,
            },
          ],
          groupBy: [],
          pageId: "6202832b3bbf2abc3963d3dd",
          widgetCategory: "chart",
          widgetType: "ag_table",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJ2dWVfRWR1Y2F0ZXVyczw-TmJRdWFsaWYiLCAiY29sdW1uTmFtZSI6ICIjcXVhbGlmIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "9c7318bc-c8e4-446d-87fb-1234cca89c0c",
                aggFunction: "count",
                distinct: false,
              },
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "8221d529-715c-4cf2-9b8a-82d5eeb93fc9",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "639cd823-51c8-43e8-8f5d-33b81d302100",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "qualifications_percent",
          },
          category: {},
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "55732d7c-2d01-4426-a06a-112b0d6126d9",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "fb3f9bc3-c325-4730-b893-30c284649a0c",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "476c1b37-f8c1-4017-938f-904ed134cd82",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJ2dWVfRWR1Y2F0ZXVyczw-TmJRdWFsaWYiLCAiY29sdW1uTmFtZSI6ICIjcXVhbGlmIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJ2dWVfRWR1Y2F0ZXVyczw-TmJRdWFsaWYiLCAiY29sdW1uTmFtZSI6ICIjcXVhbGlmIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "#qualif",
              calculus: "mean",
              conditions: {},
            },
          ],
          groupBy: [],
          pageId: "6202832b3bbf2abc3963d3dd",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJjc3YiLCAibmFtZSI6ICJ2dWVfRWR1Y2F0ZXVyczw-TmJRdWFsaWYiLCAiY29sdW1uTmFtZSI6ICIjcXVhbGlmIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "476c1b37-f8c1-4017-938f-904ed134cd82",
                aggFunction: "mean",
                distinct: false,
              },
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "55732d7c-2d01-4426-a06a-112b0d6126d9",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "fb3f9bc3-c325-4730-b893-30c284649a0c",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          widgetCategory: "chart",
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "top_discipline",
          },
          title: "Top discipline",
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBFQVBTLWZvcm9tIiwgImNvbHVtbk5hbWUiOiAiZGlzY2lwbGluZV9vYnNlcnZhdG9pcmUifSwgInZlcnNpb24iOiAyfQ==",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "831f0f42-f282-4476-9924-adc9a034d18a",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "3eecf635-f3e5-4caa-b905-d161e6bdec28",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "4fb3007f-1d44-456c-a7d5-8f9dbc874c00",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogImZvclx1MDBmNG1lcyIsICJjb2x1bW5OYW1lIjogIk5cdTAwYjBvcmRyZSJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogImZvclx1MDBmNG1lcyIsICJjb2x1bW5OYW1lIjogIk5cdTAwYjBvcmRyZSJ9LCAidmVyc2lvbiI6IDJ9",
              name: "N°ordre",
              calculus: "count",
              conditions: {},
              distinct: false,
            },
          ],
          groupBy: [
            {
              valueId: "2265f51f-1c33-4539-8284-3e0ffd2bb3c8",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBFQVBTLWZvcm9tIiwgImNvbHVtbk5hbWUiOiAiZGlzY2lwbGluZV9vYnNlcnZhdG9pcmUifSwgInZlcnNpb24iOiAyfQ==",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBFQVBTLWZvcm9tIiwgImNvbHVtbk5hbWUiOiAiZGlzY2lwbGluZV9vYnNlcnZhdG9pcmUifSwgInZlcnNpb24iOiAyfQ==",
              name: "discipline_observatoire",
              calculus: "sum",
              conditions: {},
            },
          ],
          isAdvancedConfig: {
            data: true,
            category: false,
            dependsOnField: false,
            groupBy: false,
          },
          pageId: "6202832b3bbf2abc3963d3dd",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogImZvclx1MDBmNG1lcyIsICJjb2x1bW5OYW1lIjogIk5cdTAwYjBvcmRyZSJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "4fb3007f-1d44-456c-a7d5-8f9dbc874c00",
                aggFunction: "count",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBFQVBTLWZvcm9tIiwgImNvbHVtbk5hbWUiOiAiZGlzY2lwbGluZV9vYnNlcnZhdG9pcmUifSwgInZlcnNpb24iOiAyfQ==",
                outputUUID: "2265f51f-1c33-4539-8284-3e0ffd2bb3c8",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBFQVBTLWZvcm9tIiwgImNvbHVtbk5hbWUiOiAiZGlzY2lwbGluZV9vYnNlcnZhdG9pcmUifSwgInZlcnNpb24iOiAyfQ==",
            ],
            sort: {
              fields: [
                "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogImZvclx1MDBmNG1lcyIsICJjb2x1bW5OYW1lIjogIk5cdTAwYjBvcmRyZSJ9LCAidmVyc2lvbiI6IDJ9",
              ],
              ascending: false,
            },
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "831f0f42-f282-4476-9924-adc9a034d18a",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "3eecf635-f3e5-4caa-b905-d161e6bdec28",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            limit: 1,
          },
          requestInformations: {
            sort: {
              sortingType: "bestResult",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogImZvclx1MDBmNG1lcyIsICJjb2x1bW5OYW1lIjogIk5cdTAwYjBvcmRyZSJ9LCAidmVyc2lvbiI6IDJ9",
            },
            limit: 1,
          },
          widgetCategory: "chart",
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
    ]
  } else if (location === "pratiquants") {
    return [
      {
        widgetInfo: {
          _id: {
            $oid: "licences_par_dep",
          },
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiQW5uXHUwMGU5ZSJ9LCAidmVyc2lvbiI6IDJ9",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "17d3336a-a15a-4477-9846-5d8bcbf74886",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "a7f02402-a38c-407a-99f3-4083b42af7c7",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "1f1c0f29-6206-44a2-b7d0-6e930dd2731c",
                    fieldInformation: {
                      label: "Année",
                      color: "#F9C846",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBkZXMgRlx1MDBlOWRcdTAwZTlyYXRpb24gcGFyIEFublx1MDBlOWUiLCAiY29sdW1uTmFtZSI6ICJBbm5cdTAwZTllIn0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: "2019",
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "c511c765-5027-4f03-8acd-f2bdb74db014",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Nombre_licences",
              calculus: "sum",
              conditions: {},
            },
          ],
          groupBy: [
            {
              valueId: "78b7ac99-c069-47a6-9230-5f556381cea2",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiQW5uXHUwMGU5ZSJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiQW5uXHUwMGU5ZSJ9LCAidmVyc2lvbiI6IDJ9",
              name: "Année",
              calculus: "sum",
              conditions: {},
            },
          ],
          pageId: "644a33dab5aa1c62c0144aa7",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "c511c765-5027-4f03-8acd-f2bdb74db014",
                aggFunction: "sum",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiQW5uXHUwMGU5ZSJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "78b7ac99-c069-47a6-9230-5f556381cea2",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiQW5uXHUwMGU5ZSJ9LCAidmVyc2lvbiI6IDJ9",
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "17d3336a-a15a-4477-9846-5d8bcbf74886",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "a7f02402-a38c-407a-99f3-4083b42af7c7",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "1f1c0f29-6206-44a2-b7d0-6e930dd2731c",
                          fieldInformation: {
                            label: "Année",
                            color: "#F9C846",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBkZXMgRlx1MDBlOWRcdTAwZTlyYXRpb24gcGFyIEFublx1MDBlOWUiLCAiY29sdW1uTmFtZSI6ICJBbm5cdTAwZTllIn0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: "2019",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          requestInformations: {},
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "licences_masculine_par_dep",
          },
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "12ca4287-80b3-414d-8948-5cc0c93f4ee6",
                    fieldInformation: {
                      label: "Sexe licence",
                      color: "#F9C846",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: "Licences masculines",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "17d3336a-a15a-4477-9846-5d8bcbf74886",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "a7f02402-a38c-407a-99f3-4083b42af7c7",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "6a323146-df00-4f71-be5c-ed8e9183c4d2",
                    fieldInformation: {
                      label: "Année",
                      color: "#F9C846",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBkZXMgRlx1MDBlOWRcdTAwZTlyYXRpb24gcGFyIEFublx1MDBlOWUiLCAiY29sdW1uTmFtZSI6ICJBbm5cdTAwZTllIn0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: "2019",
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "c511c765-5027-4f03-8acd-f2bdb74db014",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Nombre_licences",
              calculus: "sum",
              conditions: {},
            },
          ],
          groupBy: [
            {
              valueId: "aa0bb784-de5b-4086-9414-3f2c5e8240da",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Sexe licence",
              calculus: "sum",
              conditions: {},
            },
          ],
          pageId: "644a33dab5aa1c62c0144aa7",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "c511c765-5027-4f03-8acd-f2bdb74db014",
                aggFunction: "sum",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "aa0bb784-de5b-4086-9414-3f2c5e8240da",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "12ca4287-80b3-414d-8948-5cc0c93f4ee6",
                          fieldInformation: {
                            label: "Sexe licence",
                            color: "#F9C846",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: "Licences masculines",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "17d3336a-a15a-4477-9846-5d8bcbf74886",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "a7f02402-a38c-407a-99f3-4083b42af7c7",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "6a323146-df00-4f71-be5c-ed8e9183c4d2",
                          fieldInformation: {
                            label: "Année",
                            color: "#F9C846",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBkZXMgRlx1MDBlOWRcdTAwZTlyYXRpb24gcGFyIEFublx1MDBlOWUiLCAiY29sdW1uTmFtZSI6ICJBbm5cdTAwZTllIn0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: "2019",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          requestInformations: {},
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "licences_feminine_par_dep",
          },
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "12ca4287-80b3-414d-8948-5cc0c93f4ee6",
                    fieldInformation: {
                      label: "Sexe licence",
                      color: "#F9C846",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: "Licences féminines",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "17d3336a-a15a-4477-9846-5d8bcbf74886",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "a7f02402-a38c-407a-99f3-4083b42af7c7",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "6a323146-df00-4f71-be5c-ed8e9183c4d2",
                    fieldInformation: {
                      label: "Année",
                      color: "#F9C846",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBkZXMgRlx1MDBlOWRcdTAwZTlyYXRpb24gcGFyIEFublx1MDBlOWUiLCAiY29sdW1uTmFtZSI6ICJBbm5cdTAwZTllIn0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: "2019",
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "c511c765-5027-4f03-8acd-f2bdb74db014",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Nombre_licences",
              calculus: "sum",
              conditions: {},
            },
          ],
          groupBy: [
            {
              valueId: "aa0bb784-de5b-4086-9414-3f2c5e8240da",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Sexe licence",
              calculus: "sum",
              conditions: {},
            },
          ],
          pageId: "621501fd3bbf2abc3966f103",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "c511c765-5027-4f03-8acd-f2bdb74db014",
                aggFunction: "sum",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "aa0bb784-de5b-4086-9414-3f2c5e8240da",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "12ca4287-80b3-414d-8948-5cc0c93f4ee6",
                          fieldInformation: {
                            label: "Sexe licence",
                            color: "#F9C846",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiU2V4ZSBsaWNlbmNlIn0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: "Licences féminines",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "17d3336a-a15a-4477-9846-5d8bcbf74886",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "a7f02402-a38c-407a-99f3-4083b42af7c7",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "6a323146-df00-4f71-be5c-ed8e9183c4d2",
                          fieldInformation: {
                            label: "Année",
                            color: "#F9C846",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBkZXMgRlx1MDBlOWRcdTAwZTlyYXRpb24gcGFyIEFublx1MDBlOWUiLCAiY29sdW1uTmFtZSI6ICJBbm5cdTAwZTllIn0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: "2019",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          title: "Licences féminine par dep",
          widgetCategory: "chart",
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "ff_licences_par_dep",
          },
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiRlx1MDBlOWRcdTAwZTlyYXRpb24ifSwgInZlcnNpb24iOiAyfQ==",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "8cd9e31c-7805-456f-b47d-323951b5ea28",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "d65df756-b280-4c5a-a751-f905a4587f9a",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "7093172d-9c6a-4966-a898-8a6bc8f48777",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Nombre_licences",
              calculus: "sum",
              conditions: {},
            },
          ],
          groupBy: [
            {
              valueId: "04a77fa5-5114-4f7d-96c7-a761ea880ae0",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiRlx1MDBlOWRcdTAwZTlyYXRpb24ifSwgInZlcnNpb24iOiAyfQ==",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiRlx1MDBlOWRcdTAwZTlyYXRpb24ifSwgInZlcnNpb24iOiAyfQ==",
              name: "Fédération",
              calculus: "sum",
              conditions: {},
            },
          ],
          pageId: "621501fd3bbf2abc3966f103",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "7093172d-9c6a-4966-a898-8a6bc8f48777",
                aggFunction: "sum",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiRlx1MDBlOWRcdTAwZTlyYXRpb24ifSwgInZlcnNpb24iOiAyfQ==",
                outputUUID: "04a77fa5-5114-4f7d-96c7-a761ea880ae0",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiRlx1MDBlOWRcdTAwZTlyYXRpb24ifSwgInZlcnNpb24iOiAyfQ==",
            ],
            sort: {
              fields: [
                "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
              ],
              ascending: false,
            },
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "8cd9e31c-7805-456f-b47d-323951b5ea28",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "d65df756-b280-4c5a-a751-f905a4587f9a",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            limit: 1,
          },
          requestInformations: {
            sort: {
              sortingType: "bestResult",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBsaWNlbmNlcyBwYXIgU2V4ZSBldCBEXHUwMGU5cGFydGVtZW50IiwgImNvbHVtbk5hbWUiOiAiTm9tYnJlX2xpY2VuY2VzIn0sICJ2ZXJzaW9uIjogMn0=",
            },
            limit: 1,
          },
          title: "FF licences par dep",
          widgetCategory: "chart",
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "clubs_par_dep",
          },
          category: {},
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "571770d1-e42a-40a1-823f-7e745788bb0d",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "f5b017d8-0f65-4811-8115-73dfe71c3c1a",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "42cd9d07-5bde-49bf-8ab8-362804fa70bb",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
              name: "Nombre_clubs",
              calculus: "sum",
              conditions: {},
              distinct: false,
            },
          ],
          groupBy: [],
          pageId: "621501fd3bbf2abc3966f103",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "42cd9d07-5bde-49bf-8ab8-362804fa70bb",
                aggFunction: "sum",
                distinct: false,
              },
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "571770d1-e42a-40a1-823f-7e745788bb0d",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "f5b017d8-0f65-4811-8115-73dfe71c3c1a",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
          title: "Clubs par dep",
          widgetCategory: "chart",
          widgetType: "ag_table",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
      {
        widgetInfo: {
          _id: {
            $oid: "ff_clubs_par_dep",
          },
          category: {
            id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIkZcdTAwZTlkXHUwMGU5cmF0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
            sortingType: "default",
          },
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "5397af08-73f8-43fb-bf9b-3ba7877b6df9",
                    fieldInformation: {
                      label: "sport_nature",
                      color: "#F96E46",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                    operation: "==",
                    value: "oui",
                  },
                ],
              },
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "d3914a9b-5eae-48d9-ba57-91c2a3dfa546",
                    fieldInformation: {
                      label: "NUMÉRO département",
                      color: "#14213D",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "38afae0a-8560-49b1-8758-70ffbf344bb4",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
              name: "Nombre_clubs",
              calculus: "sum",
              conditions: {},
            },
          ],
          groupBy: [
            {
              valueId: "3a6d7fac-839e-4213-ab5b-8b553961769c",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIkZcdTAwZTlkXHUwMGU5cmF0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIkZcdTAwZTlkXHUwMGU5cmF0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
              name: "Fédération",
              calculus: "sum",
              conditions: {},
            },
          ],
          pageId: "644a33dab5aa1c62c0144aa7",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "38afae0a-8560-49b1-8758-70ffbf344bb4",
                aggFunction: "sum",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIkZcdTAwZTlkXHUwMGU5cmF0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
                outputUUID: "3a6d7fac-839e-4213-ab5b-8b553961769c",
                aggFunction: "",
              },
            ],
            groupByFieldUUIDs: [
              "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIkZcdTAwZTlkXHUwMGU5cmF0aW9uIn0sICJ2ZXJzaW9uIjogMn0=",
            ],
            sort: {
              fields: [
                "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
              ],
              ascending: false,
            },
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "5397af08-73f8-43fb-bf9b-3ba7877b6df9",
                          fieldInformation: {
                            label: "sport_nature",
                            color: "#F96E46",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlmXHUwMGU5cmVudGllbCBEaXNjaXBsaW5lIFNwb3J0IGRlIE5hdHVyZSIsICJjb2x1bW5OYW1lIjogInNwb3J0X25hdHVyZSJ9LCAidmVyc2lvbiI6IDJ9",
                          operation: "==",
                          value: "oui",
                        },
                      ],
                    },
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "d3914a9b-5eae-48d9-ba57-91c2a3dfa546",
                          fieldInformation: {
                            label: "NUMÉRO département",
                            color: "#14213D",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIlJcdTAwZTlnaW9ucywgRFx1MDBlOXBhcnRlbWVudHMgZXQgQ2hlZiBMaWV1IiwgImNvbHVtbk5hbWUiOiAiTlVNRVx1MDMwMVJPIGRlXHUwMzAxcGFydGVtZW50In0sICJ2ZXJzaW9uIjogMn0=",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            limit: 1,
          },
          requestInformations: {
            sort: {
              sortingType: "bestResult",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIk5vbWJyZSBkZSBjbHVicyBwYXIgRFx1MDBlOXBhcnRlbWVudCIsICJjb2x1bW5OYW1lIjogIk5vbWJyZV9jbHVicyJ9LCAidmVyc2lvbiI6IDJ9",
            },
            limit: 1,
          },
          title: "FF clubs par dep",
          widgetCategory: "chart",
          widgetType: "histogram",
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
    ]
  } else if (location === "lieux-de-pratique") {
    return [
      {
        widgetInfo: {
          _id: {
            $oid: "INDICATEUR_POLITIQUE",
          },
          canBeCompared: true,
          category: {},
          chartType: "ag_table",
          conditions: {
            operation: "and",
            filters: [
              {
                operation: "or",
                filters: [
                  {
                    conditionId: "f233baca-75b4-421a-8b2a-e31e36f96a27",
                    fieldInformation: {
                      label: "num_dept",
                      color: "#FCA311",
                    },
                    fieldUUID:
                      "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAibnVtX2RlcHQifSwgInZlcnNpb24iOiAyfQ==",
                    operation: "==",
                    value: departement,
                  },
                ],
              },
            ],
          },
          data: [
            {
              valueId: "c41aef0e-ffe7-4204-bf59-97832302a586",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiYXZhbmNlbWVudF9DREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiYXZhbmNlbWVudF9DREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
              name: "avancement_CDESI",
              calculus: "",
              conditions: {},
            },
            {
              valueId: "c7db79bc-69f0-4228-8669-2d530174c71a",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAicHJlc2VuY2VfUERFU0kifSwgInZlcnNpb24iOiAyfQ==",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAicHJlc2VuY2VfUERFU0kifSwgInZlcnNpb24iOiAyfQ==",
              name: "presence_PDESI",
              calculus: "",
              conditions: {},
            },
            {
              valueId: "5f25497d-d177-4e5a-8bfc-c0ea5db620d2",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiZGF0ZV9pbnN0aXR1dGlvbl9QREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiZGF0ZV9pbnN0aXR1dGlvbl9QREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
              name: "date_institution_PDESI",
              calculus: "",
              conditions: {},
            },
            {
              valueId: "37b12825-e10a-4efb-9eed-c834b0c829d3",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiZGF0ZV9pbnN0aXR1dGlvbl9DREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiZGF0ZV9pbnN0aXR1dGlvbl9DREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
              name: "date_institution_CDESI",
              calculus: "",
              conditions: {},
            },
            {
              valueId: "b4d8955f-06fa-4b98-a629-28d83a9a3b7a",
              id: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAicHJlc2VuY2VfUERJUFIifSwgInZlcnNpb24iOiAyfQ==",
              uuid: "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAicHJlc2VuY2VfUERJUFIifSwgInZlcnNpb24iOiAyfQ==",
              name: "presence_PDIPR",
              calculus: "",
              conditions: {},
            },
          ],
          groupBy: [],
          pageId: "644a42bfb5aa1c62c0147a22",
          widgetType: "ag_table",
          request: {
            selectAdvanced: [
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiYXZhbmNlbWVudF9DREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "c41aef0e-ffe7-4204-bf59-97832302a586",
                aggFunction: "",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAicHJlc2VuY2VfUERFU0kifSwgInZlcnNpb24iOiAyfQ==",
                outputUUID: "c7db79bc-69f0-4228-8669-2d530174c71a",
                aggFunction: "",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiZGF0ZV9pbnN0aXR1dGlvbl9QREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "5f25497d-d177-4e5a-8bfc-c0ea5db620d2",
                aggFunction: "",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAiZGF0ZV9pbnN0aXR1dGlvbl9DREVTSSJ9LCAidmVyc2lvbiI6IDJ9",
                outputUUID: "37b12825-e10a-4efb-9eed-c834b0c829d3",
                aggFunction: "",
                distinct: false,
              },
              {
                fieldUUID:
                  "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAicHJlc2VuY2VfUERJUFIifSwgInZlcnNpb24iOiAyfQ==",
                outputUUID: "b4d8955f-06fa-4b98-a629-28d83a9a3b7a",
                aggFunction: "",
                distinct: false,
              },
            ],
            filter: {
              operation: "and",
              filters: [
                {
                  operation: "and",
                  filters: [
                    {
                      operation: "or",
                      filters: [
                        {
                          conditionId: "f233baca-75b4-421a-8b2a-e31e36f96a27",
                          fieldInformation: {
                            label: "num_dept",
                            color: "#FCA311",
                          },
                          fieldUUID:
                            "eyJkYXRhIjogeyJjYXRlZ29yeSI6ICJleGNlbCIsICJuYW1lIjogIklORElDQVRFVVJfUE9MSVRJUVVFIiwgImNvbHVtbk5hbWUiOiAibnVtX2RlcHQifSwgInZlcnNpb24iOiAyfQ==",
                          operation: "==",
                          value: departement,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        },
        valueFilterSelected: {},
        fieldsData: [],
        dataChangeType: "dataChange",
        comparisonValues: {},
      },
    ]
  } else return []
}

const getPresenceCDESI = value => {
  if (
    value === "CDESI installée (réunie au moins une fois)" ||
    "CDESI instituée (délibération du Conseil départemental)"
  ) {
    return "Oui"
  } else if (value === "") {
  } else {
  }
}

const getAvancementCDESI = value => {
  if (value === "CDESI installée (réunie au moins une fois)") {
    return "Installée"
  } else if (value === "CDESI instituée (délibération du Conseil départemental)") {
    return "Instituée"
  } else {
    return ""
  }
}

const getAnneeCDESI = (value, data) => {
  if (value === "CDESI installée (réunie au moins une fois)") {
    return new Date(
      data?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.["7fcf7304-be46-42f9-bcb1-2eda08c8a272"]
    ).toLocaleDateString("fr-FR")
  } else if (value === "CDESI instituée (délibération du Conseil départemental)") {
    return new Date(
      data?.["INDICATEUR_POLITIQUE"]?.data?.[0]?.["e3af509d-1bf3-41bf-8766-cca03bfa23da"]
    ).toLocaleDateString("fr-FR")
  } else {
    return ""
  }
}

const getLabelAnneeCDESI = value => {
  if (value === "CDESI installée (réunie au moins une fois)") {
    return "d'installation : "
  } else if (value === "CDESI instituée (délibération du Conseil départemental)") {
    return "d'institution : "
  } else {
    return ""
  }
}

const getPresencePDESI = value => {
  if (value === "Oui") {
    return "Oui"
  } else if (
    value === "Non, mais c'est envisagé" ||
    value === "Non, mais en cours d'élaboration" ||
    value === "Non, ce n'est pas un projet"
  ) {
    return "non"
  } else {
    return ""
  }
}

const getPresencePDIPR = value => {
  if (value === "Oui") {
    return "Oui"
  } else {
    return "Non"
  }
}
//   {
//     widgetInfo: {},
//     valueFilterSelected: {},
//     fieldsData: [],
//     dataChangeType: "dataChange",
//     comparisonValues: {}
//   }
